import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebase.config';
import { doc, getDoc } from 'firebase/firestore';
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import Progress from "../component/sidebar/progress";
import Rating from "../component/sidebar/rating";

const InstructorSHowPage = () => {
  const { instructorId } = useParams();
  const [instructorData, setInstructorData] = useState(null);

  useEffect(() => {
    const fetchInstructorData = async () => {
      try {
        const instructorRef = doc(db, 'instructors', instructorId);
        const instructorSnapshot = await getDoc(instructorRef);

        if (instructorSnapshot.exists()) {
          setInstructorData(instructorSnapshot.data());
        } else {
          console.log('No such instructor!');
        }
      } catch (error) {
        console.error('Error fetching instructor data:', error);
      }
    };

    fetchInstructorData();
  }, [instructorId]);

  if (!instructorData) {
    return <div>Loading...</div>;
  }

  const {
    name,
    degi,
    desc,
    subTitle,
    infoDetails,
    memInfoList,
    memSocialList,
    skillList,
    awardList,
    profileUrl
  } = instructorData;

  return (
    <>
      <Header />
      <PageHeader title={`Sir ${name}`} curPage={name} />
      <section className="instructor-single-section padding-tb section-bg">
        <div className="container">
          <div className="instructor-wrapper">
            <div className="instructor-single-top">
              <div className="instructor-single-item d-flex flex-wrap justify-content-between">
                <div className="instructor-single-thumb">
                  <img src={profileUrl} alt="instructor" />
                </div>
                <div className="instructor-single-content">
                  <h4 className="title">{name}</h4>
                  <p className="ins-dege">{degi}</p>
                  <Rating />
                  <p className="ins-desc">{desc}</p>
                  <h6 className="subtitle">{subTitle}</h6>
                  <p className="ins-desc">{infoDetails}</p>
                  <ul className="lab-ul">
                    {memInfoList.map((val, i) => (
                      <li className="d-flex flex-wrap justify-content-start" key={i}>
                        <span className="list-name">{val.leftText}</span>
                        <span className="list-attr">{val.rightText}</span>
                      </li>
                    ))}
                    <li className="d-flex flex-wrap justify-content-start">
                      <span className="list-name">Follow Us</span>
                      <ul className="lab-ul list-attr d-flex flex-wrap justify-content-start">
                        {memSocialList.map((val, i) => (
                          <li key={i}>
                            <a className={val.className} href={val.siteLink}><i className={val.iconName}></i></a>
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="instructor-single-bottom d-flex flex-wrap mt-4">
              <div className="col-xl-6 pb-5 pb-xl-0 d-flex flex-wrap justify-content-lg-start justify-content-between">
                <h4 className="subtitle">Personal Language Skill</h4>
                {skillList.map((val, i) => (
                  <div className="text-center skill-item" key={i}>
                    <div className="skill-thumb">
                      <Progress strokeWidth={8} percentage={val.percentage} />
                    </div>
                    <p>{val.text}</p>
                  </div>
                ))}
              </div>
              <div className="col-xl-6">
                <h4 className="subtitle">Recognitions Award</h4>
                <ul className="lab-ul award-lists">
                  {awardList.map((val, i) => (
                    <li key={i}>
                      <div className="award-item">
                        <div className="award-thumb">
                          <img src={val.imgUrl} alt={val.imgAlt} />
                        </div>
                        <span>{val.text}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default InstructorSHowPage;